import React from "react";
import CollectionCategoriesItem from "components/collectionCategoriesItem/CollectionCategoriesItem";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation } from "swiper";
import { Pagination } from "swiper";

export default function CollectionsCategories({ category, items }) {
  return (
    <div className="CollectionsCategories w-full rounded-2xl">
      <CollectionCategoriesItem item={items} category={category} />
    </div>
  );
}
